import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { db } from "../../config/firebase";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { toast } from "react-toastify";
import CountrySelectInput from "../shared/countrySelectInput";
import { generatePDF } from "../shared/pdf/generatePDF";
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { useNavigate, useParams } from "react-router-dom";
// import useNextQuoteNumber from "./quoteNumber";
import { AmountFormat } from "../../lib/helper/amountFormat";
import InsuranceCheckbox from "./helperComponent/insuranceCheckBox";
import CIFValue from "./helperComponent/CIFValue";
import ValidityDate from "./helperComponent/validityDate";
import ServiceTemp from "./servicesTemp/temp";
// import getNextQuoteNumber from "./GetNextQuotNumber";
import { getSettings } from "../../lib/setting";
import { useQuery } from "@tanstack/react-query";
import QuotNumberErrorModal from "./QuotNumberErrorModal";
import TransportationMode from "./TransportationMode";
import CurrencyComponent from "./CurrencyComponent";
import { validateFormData } from "./helperComponent/Funtions";
import { Select, message } from "antd";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import CustomButton from "../shared/common/customButton";
import DashboardLayout from "../layout";
import { api } from "../../config/api";
import { useQueryClient } from "@tanstack/react-query";
import DiscountInput from "./helperComponent/DiscountInput";
const AddQuotesFromRequest = () => {
  const obj = {
    ative: true,
    content: "Quote List",
  };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { id } = useParams();
  const [Total, setTotal] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);


  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [templateSelected, setTemplateSelected] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");
  const getDefaultValidityDate = () => {
    const creationDate = new Date();
    creationDate.setDate(creationDate.getDate() + 10);
    return creationDate.toISOString().split("T")[0]; // Get the date part only
  };
  // Initialize form data with default values
  const initialFormData = {
    status: "pending",
    sendStatus: true,
    quoteNumber: "",
    validityDate: getDefaultValidityDate() || "",
    requestId: id || "",
    companyName: "",
    userId: "",
    name: "", // Use default value if customerData is null
    email: "",
    postalCode: "",
    address: "",
    country: "",
    loadAddress: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    unloadAddress: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    unloadAddress_CompanyName: "",
    modeOfTransfer: "By Road",
    cargoValue: { value: "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "Kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: totalWeight,
    description: "",
    services: [
      {
        numberOfItem: "",
        description: "",
        exclVAT: "",
      },
    ],
    total: Total,
    subTotal: 0,
    vatPercentage: "",
    vatAmount: 0,
    insurance: 0,
    currency: "USD",
  };

  const [formData, setFormData] = useState(initialFormData);

  const { data: settingsData, isLoading: settingsLoading } = useQuery(
    ["settings"],
    getSettings,
    {
      refetchOnWindowFocus: false,
    }
  );

  // Update quote number when settingsData becomes available
  useEffect(() => {
    const validateAndSetQuoteNumber = async () => {
      if (settingsData?.quoteNumber_Prefix) {
        try {
          // Get all quotes to check for existing numbers
          const quotesRef = collection(db, "quotes");
          const querySnapshot = await getDocs(quotesRef);
          const existingQuotes = querySnapshot.docs.map(doc => doc.data().quoteNumber);

          // Check if current prefix exists
          if (existingQuotes.includes(settingsData.quoteNumber_Prefix)) {
            // Extract the base part and numeric part
            const basePart = settingsData.quoteNumber_Prefix.slice(0, -4); // Get everything except last 4 digits
            const currentNumber = parseInt(settingsData.quoteNumber_Prefix.slice(-4));

            // Find the next available number
            let nextNumber = currentNumber;
            let nextQuoteNumber;

            do {
              nextNumber++;
              nextQuoteNumber = `${basePart}${nextNumber.toString().padStart(4, '0')}`;
            } while (existingQuotes.includes(nextQuoteNumber));

            setShowError(true);
            setNewNumber(nextQuoteNumber);
          }

          // Set the initial quote number from settings
          setFormData(prevData => ({
            ...prevData,
            quoteNumber: settingsData.quoteNumber_Prefix
          }));
        } catch (error) {
          console.error("Error validating quote number:", error);
          toast.error("Error validating quote number");
        }
      }
    };

    validateAndSetQuoteNumber();
  }, [settingsData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDocRef = doc(db, "requests", id);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          // Update formData state with fetched data, ensuring nested objects are initialized
          setFormData((prevData) => ({
            ...prevData,
            ...data,
            userId: data?.userId,
            cargoValue: data?.cargoValue ?? { value: "", currency: "USD" },
            cifValue: data?.cifValue ?? { value: "", currency: "USD" },
            // treat 0 (unset) as blank in the UI
            vatPercentage:
              data?.vatPercentage === 0 || data?.vatPercentage === undefined
                ? ""
                : data?.vatPercentage,
            pcsPackage: data?.pcsPackage ?? [
              {
                quantity: "",
                weight: { value: "", unit: "Kg" },
                length: { value: "", unit: "cm" },
                width: { value: "", unit: "cm" },
                height: { value: "", unit: "cm" },
              },
            ],
          }));
        } else {
          toast.error("Quote data not found");
        }
      } catch (error) {
        console.error("Error fetching Quote data:", error);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    // Calculate Sub Total and separate discountable base services
    let subTotal = 0;
    let discountableSubTotal = 0;

    formData.services.forEach((service) => {
      const totalForService =
        parseFloat(service.numberOfItem || 1) *
        parseFloat(service.exclVAT || 0);
      subTotal += totalForService;

      const desc = (service.description || "").trim().toLowerCase();
      const isTaxOrDuty =
        desc === "vat" ||
        desc.includes("duty") ||
        desc.includes("duties") ||
        desc.includes("tax");

      if (!isTaxOrDuty) {
        discountableSubTotal += totalForService;
      }
    });

    // Calculate Discount — applies only to base services subtotal, excluding VAT/Duties/Taxes
    const rawDiscount = parseFloat(discountValue) || 0;
    let discountAmount = 0;
    if (rawDiscount > 0) {
      if (discountType === "percentage") {
        discountAmount = (discountableSubTotal * rawDiscount) / 100;
      } else {
        discountAmount = rawDiscount;
      }
      // Clamp so discount never exceeds discountableSubTotal
      discountAmount = Math.min(discountAmount, discountableSubTotal);
    }
    const discountedSubTotal = subTotal - discountAmount;

    // Calculate VAT Amount (calculated on base subtotal, NOT discounted)
    const vatPercentage = parseFloat(formData.vatPercentage || 0);
    const vatAmount =
      vatPercentage === 0 ? 0 : (subTotal * vatPercentage) / 100;

    // Calculate Total including VAT
    let total = discountedSubTotal + vatAmount;

    // Calculate InsuranceTotal including insurance
    let InsuranceTotal = total;
    const insuranceValue = parseFloat(formData.insurance || 0);
    if (insuranceValue !== 0) {
      InsuranceTotal += insuranceValue;
    }

    // Format total to display only two decimal points
    const formattedTotal = InsuranceTotal.toFixed(2);

    // Discount metadata
    const discountData = discountAmount > 0
      ? {
          type: discountType,
          value: rawDiscount,
          amount: parseFloat(discountAmount.toFixed(2)),
          servicesSubtotalBeforeDiscount: discountableSubTotal,
        }
      : null;

    // Update state
    setTotal(formattedTotal);
    setFormData((prevData) => ({
      ...prevData,
      subTotal: subTotal.toFixed(2), // Update subTotal
      vatAmount: vatAmount.toFixed(2), // Update vatAmount
      total: formattedTotal, // Update total
      discount: discountData,
    }));
  }, [formData.services, formData.vatPercentage, formData.insurance, discountType, discountValue]);
  // console.log(formData)

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "vatPercentage") {
      // VAT is optional; allow empty and non-negative numbers
      const numValue = value === "" ? "" : parseFloat(value);
      if (value === "" || (!isNaN(numValue) && numValue >= 0)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value === "" ? "" : numValue,
        }));
        // remove from invalid list if present
        setInvalidFields((prev) => prev.filter((field) => field !== "vatPercentage"));
      } else {
        // mark invalid when negative/invalid
        setInvalidFields((prev) => (prev.includes("vatPercentage") ? prev : [...prev, "vatPercentage"]));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handlePcsOfPkgInput = (index, field, e) => {
    const { name, value } = e.target;

    // Prevent 'e', 'E', '+', and '-'
    if (/[eE+-]/.test(value)) {
      return;
    }
    // Convert to number and check if it's positive

    // Convert to number and check if it's greater than or equal to 1

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      // Ensure that pcsPackage array has an item at the specified index
      if (pcsPackage[index]) {
        // Update the specific nested property (quantity, weight, length, width, height)
        if (field === "quantity") {
          pcsPackage[index][field] = value;
        } else {
          pcsPackage[index][field].value = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === 'weight') {
          // Update only the weight unit
          pcsPackage[index].weight.unit = value;
        } else {
          // Update length, width, and height units together
          pcsPackage[index].length.unit = value;
          pcsPackage[index].width.unit = value;
          pcsPackage[index].height.unit = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };

  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "Kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };

  // console.log(formData)

  const [newNumber, setNewNumber] = useState("");
  const [showError, setShowError] = useState(false);

  const handleAddData = async (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    const missingFields = validateMandatoryFields(formData);
    if (missingFields.length > 0) {
      setInvalidFields(missingFields);
      toast.error("Please fill all mandatory fields.");
      return;
    }
    // if (!templateSelected) {
    //   toast.error("Please select a template before updating.");
    //   return;
    // }

    setInvalidFields([]);

    try {
      setLoading(true);
      const quotesRef = collection(db, "quotes");
      const querySnapshot = await getDocs(quotesRef);

      const existingQuotes = querySnapshot.docs.map(doc => doc.data().quoteNumber);

      if (querySnapshot.empty) {
        throw new Error("No quotes found with the specified role");
      }
      const quotesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (existingQuotes.includes(formData.quoteNumber)) {
        // Extract the base part and numeric part
        const basePart = formData.quoteNumber.slice(0, -4); // Get everything except last 4 digits
        const currentNumber = parseInt(formData.quoteNumber.slice(-4));

        // Find the next available number
        let nextNumber = currentNumber;
        let nextQuoteNumber;

        do {
          nextNumber++;
          nextQuoteNumber = `${basePart}${nextNumber.toString().padStart(4, '0')}`;
        } while (existingQuotes.includes(nextQuoteNumber));

        setShowError(true);
        setNewNumber(nextQuoteNumber);
        setLoading(false);
        return;
      }
      const usersCollection = collection(db, "quotes");
      const sanitizedVat = parseFloat(formData.vatPercentage || 0);
      await addDoc(usersCollection, {
        ...formData,
        vatPercentage: isNaN(sanitizedVat) ? 0 : sanitizedVat,
        quoteCreatedDate: new Date().toISOString(),
      });

      // Update the quote number in settings
      const settingsDocRef = doc(db, "settings", "settings");
      const basePart = formData.quoteNumber.slice(0, -4);
      const currentNumber = parseInt(formData.quoteNumber.slice(-4));
      const newQuoteNumber = `${basePart}${(currentNumber + 1).toString().padStart(4, '0')}`;

      await setDoc(settingsDocRef, {
        ...settingsData,
        quoteNumber_Prefix: newQuoteNumber
      }, { merge: true });

      // Send notification to the client
      await api.post("/notifications", {
        title: "New Quote Received",
        message: `You have received a new quote.`,
        linkText: "View Quote",
        link: `/newquotes`,
        role: "user",
        userId: formData.userId,
        quoteNumber: formData.quoteNumber,
        type: "new-quote"
      });

      await handleStatusChange();
      navigate("/quoteadmin");
      setAttemptedSubmit(false);
      toast.success("Quote saved and sent successfully!");
      queryClient.invalidateQueries(["quotes"]); // Refresh the quotes list

    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const handleDraft = async (e) => {
    e.preventDefault();

    const missingFields = validateMandatoryFields(formData);
    if (missingFields.length > 0) {
      setInvalidFields(missingFields);
      toast.error("Please fill all mandatory fields correctly.");
      return;
    }
    setInvalidFields([]);
    setLoading1(true);
    try {

      const quotesRef = collection(db, "quotes");
      const querySnapshot = await getDocs(quotesRef);

      const existingQuotes = querySnapshot.docs.map(doc => doc.data().quoteNumber);

      if (existingQuotes.includes(formData.quoteNumber)) {
        // Extract the base part and numeric part
        const basePart = formData.quoteNumber.slice(0, -4);
        const currentNumber = parseInt(formData.quoteNumber.slice(-4));

        // Find the next available number
        let nextNumber = currentNumber;
        let nextQuoteNumber;

        do {
          nextNumber++;
          nextQuoteNumber = `${basePart}${nextNumber.toString().padStart(4, '0')}`;
        } while (existingQuotes.includes(nextQuoteNumber));

        setShowError(true);
        setNewNumber(nextQuoteNumber);
        setLoading1(false);
        return;
      }

      const updatedData = {
        ...formData,
        vatPercentage: isNaN(parseFloat(formData.vatPercentage || 0))
          ? 0
          : parseFloat(formData.vatPercentage || 0),
        sendStatus: false,
        quoteCreatedDate: new Date().toISOString(),
      };

      if (querySnapshot.empty) {
        throw new Error("No quotes found with the specified role");
      }
      const quotesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const usersCollection = collection(db, "quotes");
      await addDoc(usersCollection, updatedData);

      // Update the quote number in settings
      const settingsDocRef = doc(db, "settings", "settings");
      const basePart = formData.quoteNumber.slice(0, -4);
      const currentNumber = parseInt(formData.quoteNumber.slice(-4));
      const newQuoteNumber = `${basePart}${(currentNumber + 1).toString().padStart(4, '0')}`;


      await setDoc(settingsDocRef, {
        ...settingsData,
        quoteNumber_Prefix: newQuoteNumber
      }, { merge: true });

      await api.post("/notifications", {
        title: "New Quote Received",
        message: `You have received a new quote.`,
        linkText: "View Quote",
        link: `/newquotes`,
        role: "user",
        userId: formData.userId, // Make sure formData includes the userId
        quoteNumber: formData.quoteNumber,
        type: "new-quote"
      });

      await handleStatusChange(); // Now, call handleStatusChange after adding the document
      navigate("/quoteadmin");
      toast.success("Quote saved as draft successfully!");
      queryClient.invalidateQueries(["quotes"]); // Refresh the quotes list

    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const updateAllUnits = (unit) => {
    setFormData((prevData) => {
      const newData = { ...prevData };
      newData.pcsPackage = newData.pcsPackage.map((pkg) => ({
        ...pkg,
        length: { ...pkg.length, unit },
        width: { ...pkg.width, unit },
        height: { ...pkg.height, unit },
      }));
      return newData;
    });
  };

  const handleStatusChange = async () => {
    try {
      const userDocRef = doc(db, "requests", id);
      await updateDoc(userDocRef, { requestStatus: "quoted" });
      toast.success(" status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };

  const downloadPDF = async () => {
    const missingFields = validateMandatoryFields(formData);
    if (missingFields.length > 0) {
      setInvalidFields(missingFields);
      toast.error("Please fill all mandatory fields.");
      return;
    }
    setInvalidFields([]);
    setPdfLoading(true);

    try {
      const quotesRef = collection(db, "quotes");
      const querySnapshot = await getDocs(quotesRef);
      if (querySnapshot.empty) {
        throw new Error("No quotes found with the specified role");
      }
      const quotesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const nextNumber = settingsData?.quoteNumber_Prefix || "";

      if (nextNumber.localeCompare(formData.quoteNumber) === 0) {
        const blob = await generatePDF(formData);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const fileName = `${formData.quoteNumber}.pdf`;
        link.download = fileName;
        link.click();
        setPdfLoading(false);
      } else {
        setShowError(true);
        setNewNumber(nextNumber);
        // setPdfLoading(false);
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Error generating PDF. Please try again later.");
    } finally {
      setPdfLoading(false);
    }
  };

  // New validation function
  // const validateMandatoryFields = (formData) => {
  //   const errors = [];

  //   if (!formData.loadCountry || formData.loadCountry.trim() === '') {
  //     errors.push("Load Country is required");
  //   }
  //   if (!formData.unloadCountry || formData.unloadCountry.trim() === '') {
  //     errors.push("Unload Country is required");
  //   }
  //   if (!formData.description || formData.description.trim() === '') {
  //     errors.push("Description is required");
  //   }

  //   formData.pcsPackage.forEach((pkg, index) => {
  //     if (!pkg.quantity || pkg.quantity.trim() === '') {
  //       errors.push(`Quantity is required for package ${index + 1}`);
  //     }
  //     if (!pkg.weight.value || pkg.weight.value.trim() === '') {
  //       errors.push(`Weight is required for package ${index + 1}`);
  //     }
  //     if (!pkg.length.value || pkg.length.value.trim() === '') {
  //       errors.push(`Length is required for package ${index + 1}`);
  //     }
  //     if (!pkg.width.value || pkg.width.value.trim() === '') {
  //       errors.push(`Width is required for package ${index + 1}`);
  //     }
  //     if (!pkg.height.value || pkg.height.value.trim() === '') {
  //       errors.push(`Height is required for package ${index + 1}`);
  //     }
  //   });

  //   return errors;
  // };

  const validateMandatoryFields = (formData) => {
    const missingFields = [];

    // Helper function to check if a string is empty or just whitespace

    const isEmptyOrWhitespace = (value) => {
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value == null || value === "";
    };
    // VAT percentage is optional; only negative values are invalid
    if (formData.vatPercentage !== "" && formData.vatPercentage < 0) {
      missingFields.push("vatPercentage");
    }
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    // Helper function to validate numeric fields
    const isValidNumber = (value) => {
      const num = parseFloat(value);
      return !isNaN(num) && num >= 1;
    };

    if (isEmptyOrWhitespace(formData.loadCountry))
      missingFields.push("loadCountry");
    if (isEmptyOrWhitespace(formData.unloadCountry))
      missingFields.push("unloadCountry");
    if (isEmptyOrWhitespace(formData.description))
      missingFields.push("description");

    // Validate other fields (add as needed)
    if (isEmptyOrWhitespace(formData.name)) missingFields.push("name");

    if (isEmptyOrWhitespace(formData.email) || !isValidEmail(formData.email)) {
      missingFields.push("email");
    }

    if (isEmptyOrWhitespace(formData.postalCode))
      missingFields.push("postalCode");
    if (isEmptyOrWhitespace(formData.address)) missingFields.push("address");
    if (isEmptyOrWhitespace(formData.loadAddress))
      missingFields.push("loadAddress");
    if (isEmptyOrWhitespace(formData.loadCity)) missingFields.push("loadCity");
    if (isEmptyOrWhitespace(formData.loadPostalCode))
      missingFields.push("loadPostalCode");
    if (isEmptyOrWhitespace(formData.unloadAddress))
      missingFields.push("unloadAddress");
    if (isEmptyOrWhitespace(formData.unloadCity))
      missingFields.push("unloadCity");
    if (isEmptyOrWhitespace(formData.unloadPostalCode))
      missingFields.push("unloadPostalCode");


    if (
      isEmptyOrWhitespace(formData.cargoValue.value) ||
      !isValidNumber(formData.cargoValue.value)
    ) {
      missingFields.push("cargoValue");
    }

    formData.pcsPackage.forEach((pkg, index) => {
      if (!isValidNumber(pkg.quantity)) missingFields.push(`quantity-${index}`);
      if (!isValidNumber(pkg.weight.value))
        missingFields.push(`weight-${index}`);
      if (!isValidNumber(pkg.length.value))
        missingFields.push(`length-${index}`);
      if (!isValidNumber(pkg.width.value)) missingFields.push(`width-${index}`);
      if (!isValidNumber(pkg.height.value))
        missingFields.push(`height-${index}`);
    });

    return missingFields;
  };

  useEffect(() => {
    setInvalidFields([]);
  }, [formData]);

  return (
    <>
      <DashboardLayout>
        <div className="w-full">
          <Header title="Create New Quote" />
          <div className="w-full px-4 md:px-6 lg:px-8 py-6">
            <div id="data" className="bg-white rounded-lg shadow-sm p-6 md:p-8">
              <h2 className="mx-[30px] font-bold text-xl mt-4">New Customer </h2>
              <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                <div className="flex flex-col gap-1 w-1/2  py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="quoteNumber"
                  >
                    <span className="text-red-500">*</span> Quote Number
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                    id="quoteNumber"
                    onChange={handleInputChange}
                    value={formData.quoteNumber}
                    name="quoteNumber"
                    disabled
                  />
                  <span id="emailError" style={{ color: "red" }}>
                    {showError ? "Invalid Quote number" : ""}
                  </span>
                </div>
                <ValidityDate formData={formData} setFormData={setFormData} />

                <div className="flex flex-col gap-1 py-2">
                  <label className="w-full text-sm font-normal " htmlFor="name">
                    <span className="text-red-500">*</span> Name
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("name") ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.name}
                    name="name"
                    id="name"
                    disabled
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="companyname"
                  >
                    <span className="text-red-500">*</span> Email Address
                  </label>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("email") ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.email}
                    name="email"
                    id="email"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="addressone"
                  >
                    <span className="text-red-500">*</span> Postal Code
                  </label>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("postalCode") ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.postalCode}
                    name="postalCode"
                    id="postalCode"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="addresst"
                  >
                    <span className="text-red-500">*</span> Address
                  </label>
                  <input
                    type="text"
                    placeholder="House No"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("address") ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.address}
                    name="address"
                    id="address"
                  />
                </div>
              </div>

              <div className="mx-[30px] ">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Load Address
                  </label>
                  <input
                    type="text"
                    placeholder="Street 23, new town"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("loadAddress")
                      ? "border-red-500"
                      : ""
                      }`}
                    id="loadAddress"
                    onChange={handleInputChange}
                    value={formData.loadAddress}
                    name="loadAddress"
                  />
                </div>
              </div>
              <div className="mx-[30px] grid md:grid-cols-4 grid-cols-1 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Load Country
                  </label>
                  <div
                    className={`${invalidFields.includes("loadCountry")
                      ? "border-red-500 border rounded-md"
                      : ""
                      }`}
                  >
                    <CountrySelectInput
                      label=""
                      onChange={handleInputChange}
                      value={formData.loadCountry}
                      name="loadCountry"
                      id="loadCountry"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Load City
                  </label>
                  <input
                    type="text"
                    placeholder="city name"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("loadCity") ? "border-red-500" : ""
                      }`}
                    id="loadCity"
                    onChange={handleInputChange}
                    value={formData.loadCity}
                    name="loadCity"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Load Postal Code
                  </label>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("loadPostalCode")
                      ? "border-red-500"
                      : ""
                      }`}
                    name="loadPostalCode"
                    id="loadPostalCode"
                    onChange={handleInputChange}
                    value={formData.loadPostalCode}
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load Company Name
                  </label>
                  <input
                    type="text"
                    placeholder="Load Company Name "
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue`}
                    name="loadAddress_CompanyName"
                    id="loadAddress_CompanyName"
                    onChange={handleInputChange}
                    value={formData.loadAddress_CompanyName}
                  />
                </div>
              </div>

              <div className="mx-[30px] ">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="country"
                  >
                    <span className="text-red-500">*</span> Unload Address
                  </label>
                  <input
                    type="text"
                    placeholder="Street 23, new town"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("unloadAddress")
                      ? "border-red-500"
                      : ""
                      }`}
                    id="unloadAddress"
                    onChange={handleInputChange}
                    value={formData.unloadAddress}
                    name="unloadAddress"
                  />
                </div>
              </div>

              <div className="mx-[30px] grid md:grid-cols-4 grid-cols-1 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Unload country
                  </label>
                  <div
                    className={`${invalidFields.includes("unloadCountry")
                      ? "border-red-500 border rounded-md"
                      : ""
                      }`}
                  >
                    <CountrySelectInput
                      label=""
                      onChange={handleInputChange}
                      value={formData.unloadCountry}
                      name="unloadCountry"
                      id="unloadCountry"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> unload City
                  </label>
                  <input
                    type="text"
                    placeholder="select city"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("unloadCity") ? "border-red-500" : ""
                      }`}
                    id="unloadCity"
                    onChange={handleInputChange}
                    value={formData.unloadCity}
                    name="unloadCity"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> unload Postal Code
                  </label>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("unloadPostalCode")
                      ? "border-red-500"
                      : ""
                      }`}
                    name="unloadPostalCode"
                    id="unloadPostalCode"
                    onChange={handleInputChange}
                    value={formData.unloadPostalCode}
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Unload Company Name
                  </label>
                  <input
                    type="text"
                    placeholder="unload Company Name "
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue`}
                    name="unloadAddress_CompanyName"
                    id="unloadAddress_CompanyName"
                    onChange={handleInputChange}
                    value={formData.unloadAddress_CompanyName}
                  />
                </div>
              </div>

              <div className="mx-[30px]">
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    <span className="text-red-500">*</span> Transportation Mode
                  </label>
                  <TransportationMode
                    formData={formData}
                    setFormData={setFormData}
                  />
                </div>
              </div>

              <div className="mx-[30px] grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="cargoValue"
                  >
                    <span className="text-red-500">*</span> Cargo Value
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("cargoValue")
                        ? "border-red-500"
                        : ""
                        }`}
                      name="cargoValue"
                      id="cargoValue"
                      onChange={(e) =>
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cargoValue: {
                            ...prevFormData.cargoValue,
                            value: e.target.value,
                          },
                        }))
                      }
                      value={formData.cargoValue.value || ""}
                    />
                    <Select
                      // className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name="cargoValue-currency"
                      id="cargoValue-currency"
                      onChange={(e) =>
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cargoValue: {
                            ...prevFormData.cargoValue,
                            currency: e,
                          },
                          cifValue: {
                            ...prevFormData.cifValue,
                            currency: e,
                          },
                        }))
                      }
                      value={formData.cargoValue.currency || ""}
                      options={[
                        { value: "USD", label: "USD" },
                        { value: "EUR", label: "EUR" },
                        { value: "GBP", label: "GBP" },
                      ]}
                      showSearch
                    ></Select>
                  </div>
                </div>

                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="cifValue"
                  >
                    CIF Value
                  </label>
                  <div className="flex items-center gap-1">
                    <CIFValue formData={formData} setFormData={setFormData} />

                    <Select
                      // className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name="cifValue-currency"
                      id="cifValue-currency"
                      onChange={(e) =>
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cifValue: {
                            ...prevFormData.cifValue,
                            currency: e,
                          },
                        }))
                      }
                      value={formData.cifValue.currency || ""}
                      options={[
                        { value: "USD", label: "USD" },
                        { value: "EUR", label: "EUR" },
                        { value: "GBP", label: "GBP" },
                      ]}
                      showSearch
                    ></Select>
                  </div>
                </div>
              </div>

              <h2 className="mx-[30px] font-bold text-xl mt-4">Goods</h2>

              {formData.pcsPackage.map((formItem, index) => (
                <div
                  key={index}
                  className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
                >
                  {/* Weight */}
                  <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`amount-${index}`}
                    >
                      Quantity<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`quantity-${index}`)
                        ? "border-red-500"
                        : ""
                        }`}
                      id={`quantity-${index}`}
                      onChange={(e) => handlePcsOfPkgInput(index, "quantity", e)}
                      value={formData.pcsPackage[index]?.quantity || ""}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`weight-${index}`}
                    >
                      Weight<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`weight-${index}`)
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`weight-${index}`}
                        id={`weight-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "weight", e)}
                        value={formData.pcsPackage[index]?.weight.value || ""}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`weight-unit-${index}`}
                        id={`weight-unit-${index}`}
                        onChange={(e) => handleUnitChange(index, "weight", e)}
                        value={formData.pcsPackage[index]?.weight.unit || ""}
                      >
                        <option value="kg">kg</option>
                        <option value="lbs">lbs</option>
                      </select>
                    </div>
                  </div>

                  {/* Length */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`length-${index}`}
                    >
                      Length<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`length-${index}`)
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`length-${index}`}
                        id={`length-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "length", e)}
                        value={formData.pcsPackage[index]?.length.value || ""}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`length-unit-${index}`}
                        id={`length-unit-${index}`}
                        onChange={(e) => {
                          handleUnitChange(index, "length", e)

                        }}
                        value={formData.pcsPackage[index]?.length.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                  {/* Width */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`width-${index}`}
                    >
                      Width<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`width-${index}`)
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`width-${index}`}
                        id={`width-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "width", e)}
                        value={formData.pcsPackage[index]?.width.value || ""}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`width-unit-${index}`}
                        id={`width-unit-${index}`}
                        onChange={(e) => {
                          handleUnitChange(index, "width", e)

                        }}
                        value={formData.pcsPackage[index]?.width.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                  {/* Height */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`height-${index}`}
                    >
                      Height<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`height-${index}`)
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`height-${index}`}
                        id={`height-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "height", e)}
                        value={formData.pcsPackage[index]?.height.value || ""}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`height-unit-${index}`}
                        id={`height-unit-${index}`}
                        onChange={(e) => {
                          handleUnitChange(index, "height", e)

                        }}
                        value={formData.pcsPackage[index]?.height.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                </div>
              ))}

              <div className="flex justify-between gap-5 items-center px-5 py-2">
                <div className="flex gap-1 items-center">
                  <div
                    className="mx-[20px] mt- "
                    onClick={handleAddMorePcsOfpackage}
                  >
                    <FaPlus className="text-[20px] text-[#03336E] " />
                  </div>

                  <div className="mx-[5px]  " onClick={handleRemovePcsOfpackage}>
                    <FaMinus className="text-[20px] text-[#03336E] " />
                  </div>
                </div>

                <div className="px-5 flex  items-center gap-5">
                  <p className="text-[14px]"> Total Weight:</p>
                  <p className="text-[14px] font-extrabold">
                    {formData.totalWeight ? formData.totalWeight : "00"}
                  </p>
                </div>
              </div>

              <div className="mx-[30px] flex flex-col gap-1 py-2">
                <label className="w-full text-sm font-normal " htmlFor="country">
                  <span className="text-red-500">*</span> Description
                </label>
                <textarea
                  placeholder="Description"
                  className={`w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("description") ? "border-red-500" : ""
                    }`}
                  name="description"
                  id="description"
                  onChange={handleInputChange}
                  value={formData.description}
                  maxLength={1000}
                />
              </div>

              <ServiceTemp
                formData={formData}
                setFormData={setFormData} // Add this line
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                templateSelected={templateSelected}
                setTemplateSelected={setTemplateSelected}
                attemptedSubmit={attemptedSubmit}
              />

              <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                  {/* <h1 className=" text-[16px] font-bold ">
                            Transport Warehouse - Hoofdrop
                        </h1>

                        <p className="text-[gray] ">
                            Selling Price: $0.00 excl VAT
                        </p> */}
                  <div className="flex items-center  w-full lg:w-1/2  gap-1 py-2">
                    <label className="w-full text-base font-medium">
                      VAT Percentage :<span className="text-red"></span>
                    </label>
                    <input
                      type="number"
                      className="w-full  p-2 text-sm border-2 rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name={`vatPercentage`}
                      id={`vatPercentage`}
                      onChange={(e) => handleInputChange(e)}
                      onKeyDown={(e) => {
                        if (e.key === "e" || e.key === "-" || e.key === "+") {
                          e.preventDefault();
                        }
                      }}
                      value={
                        formData.vatPercentage === "" ||
                        formData.vatPercentage === undefined ||
                        formData.vatPercentage === 0
                          ? ""
                          : formData.vatPercentage
                      }
                    />
                  </div>
                  {invalidFields.includes("vatPercentage") && (
                    <p className="text-red-500 text-sm ml-2">
                      VAT Percentage must be greater than or equal to 0
                    </p>
                  )}
                  {/* <InsuranceCheckbox
                  formData={formData}
                  setFormData={setFormData}
                /> */}
                </div>

                <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-[14px]">Sub Total</p>
                    </div>
                    <div className="">
                      <p className="text-[14px] font-extrabold">
                        {AmountFormat(formData.subTotal, formData.currency)}
                      </p>
                    </div>
                  </div>

                  <DiscountInput
                    discountType={discountType}
                    discountValue={discountValue}
                    onDiscountTypeChange={setDiscountType}
                    onDiscountValueChange={setDiscountValue}
                    currency={formData.currency}
                    discountAmount={formData.discount?.amount || 0}
                  />

                  {formData.discount && formData.discount.amount > 0 && (
                    <div className="flex justify-between mt-1 text-orange-600">
                      <div>
                        <p className="text-[14px] font-medium">
                          Discount ({formData.discount.type === 'percentage' ? `${formData.discount.value}%` : 'Fixed'})
                        </p>
                      </div>
                      <div>
                        <p className="text-[14px] font-extrabold">
                          - {AmountFormat(formData.discount.amount, formData.currency)}
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-between mt-1 ">
                    <div>
                      <p className="text-[14px]">Total VAT</p>
                    </div>
                    <div className="">
                      <p className="text-[14px] font-extrabold ">
                        {AmountFormat(formData.vatAmount, formData.currency)}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between mt-4 border-t border-cus-blue ">
                    <div className="mt-2">
                      <p className="text-[14px]">Total</p>
                    </div>
                    <div className="mt-2">
                      <p className="text-[14px] font-extrabold ">
                        {AmountFormat(formData.total, formData.currency)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
              <div className="flex gap-2 items-center">
                <CustomButton
                  label="Save and Send"
                  onClick={handleAddData}
                  loading={loading}
                />
                <CustomButton
                  label="Save "
                  onClick={handleDraft}
                  loading={loading1}
                />
              </div>

              <PDFDownloadButton onClick={downloadPDF} loading={pdfLoading} />
            </div>
          </div>
        </div>
        {showError && (
          <QuotNumberErrorModal
            isModalOpen={showError}
            setIsModalOpen={setShowError}
            data={formData}
            setFormData={setFormData}
            newNumber={newNumber}
            shouldRefresh={false}
          />
        )}
      </DashboardLayout>
    </>
  );
};

export default AddQuotesFromRequest;
